import moment from "moment/moment.js";
import React, { useEffect, useState, useCallback } from "react";
import config from "../../../config/config.js";
import tools from "../../../lib/tools.js";
import business from "../../../services/business.js";
import Loading from "../../Loading.js";
import createPushClient from "../../../lib/pushClient.js";
import Dropzone from "../../Form/Dropzone.js";
import { getAPIClient } from "../../../services/axios.js";
import { toast as alert } from "react-toastify";

const api = getAPIClient();

export default function Chat({ id }) {

    const user = config.user;

    const [comunicacao, setComunicacao] = useState([]);
    const [comentario, setComentario] = useState({
        texto: '',
        id: '',
        id_usuario: '',
        usuario_nome: '',
        data_criacao: ''
    });

    const [loading, setLoading] = useState(false);
    const [loadingFile, setLoadingFile] = useState(false);
    const [arquivos, setArquivos] = useState([]);

    // =========================================================
    // ENVIAR MENSAGEM
    // =========================================================
    const enviarMensagem = async (e) => {
        e.preventDefault();

        if (!comentario?.texto?.length) return;

        setLoading(true);

        scrollToButtom();

        const formData = new FormData();
        formData.append("id_processo", id);
        formData.append("texto", comentario.texto);
        arquivos.forEach((arquivo) => {
            formData.append(`files[]`, arquivo.file);
        });

        const { response } = await business.addComunicacao(formData);

        setLoading(false);

        if (response[0]?.id) {
            setComentario({ texto: '' });
            setArquivos([]);

            let data = {
                id: comunicacao.length + 1,
                id_usuario: parseInt(user.id),
                usuario_nome: user.nome,
                id_processo: id,
                texto: comentario.texto,
                data_criacao: tools.getDatetime(),
                arquivos: response[0]?.arquivos,
            };

            setComunicacao(prev => [...prev, data]);
        }
    };

    // =========================================================
    // SCROLL DOWN
    // =========================================================
    const scrollToButtom = () => {
        setTimeout(() => {
            const box = document.getElementsByClassName('aba-comunicacao')[0];
            if (box) box.scrollTop = box.scrollHeight;
        }, 100);
    };

    const setModel = (name, value) => {
        setComentario({ ...comentario, texto: value });
    };

    // =========================================================
    // CARREGAR MENSAGENS
    // =========================================================
    const getComunicacao = useCallback(async () => {
        setLoading(true);
        let data = await business.getComunicacaoPorProcesso(id);
        setComunicacao(data || []);
        setLoading(false);
        scrollToButtom();
    }, [id]);

    const onDrop = useCallback(acceptedFiles => {
        setArquivos((prev) => {

            let novosArquivos = [...prev];

            acceptedFiles.forEach((file) => {

                const lastId = novosArquivos.length > 0 ? novosArquivos[novosArquivos.length - 1].id : 0;

                novosArquivos.push({
                    id: lastId + 1,
                    texto: file.path,
                    file: file
                });
            });

            return novosArquivos;
        });
    }, []);

    const removeArquivo = (idArquivo) => {
        setArquivos(arquivos.filter(arquivo => arquivo.id !== idArquivo));
    };

    const viewFile = async (anexo, index) => {
        if (!anexo?.identificador) {
            alert.error("Arquivo ainda não está pronto para visualização.");
            return;
        }

        setLoadingFile({ fileId: anexo.identificador, loading: true });

        try {
            const filePath = `/processo/${id}/anexos/${anexo.identificador}.${anexo.extensao}`;
            const { data } = await api.get(`${filePath}${anexo.extensao === "zip" ? "/download/chat" : "/chat"}`);

            if (data?.response === false) {
                alert.error("Não foi possível abrir o arquivo.");
            } else {
                window.open(data.response, "_blank");
            }
        } finally {
            setLoadingFile(false);
        }
    };

    useEffect(() => {
        getComunicacao();
    }, [getComunicacao]);


    // =========================================================
    // 🔥 PUSH WEBSOCKET (com re-subscribe automático)
    // =========================================================
    useEffect(() => {
        const wsURL = process.env.REACT_APP_PUSH_WS_URL;

        // cria o cliente
        const push = createPushClient(wsURL);

        // inscreve no canal correto
        const channelName = `saa-processo-${id}`;
        const subscription = push.subscribe(channelName);

        console.log(`[PUSH] SUBSCRIBE canal -> ${channelName}`);

        // bind do evento que o backend envia
        subscription.bind("chat", (payload) => {

            console.log("🔥 PUSH CHAT RECEBIDO:", payload);

            const {
                id,
                id_processo,
                mensagem,
                id_usuario,
                data_criacao,
                data_atualizacao,
                nome_usuario
            } = payload;

            // evita receber a própria mensagem
            if (parseInt(user.id) === parseInt(id_usuario)) {
                return;
            }

            setComunicacao(prev => ([
                ...prev,
                {
                    id,
                    data_atualizacao,
                    data_criacao,
                    id_usuario,
                    id_processo,
                    texto: mensagem,
                    usuario_nome: nome_usuario
                }
            ]));

            scrollToButtom();
        });

    }, [id, user.id]);


    // =========================================================
    // RENDER
    // =========================================================
    return (
        <div className="overflow-y scrollfit h-100 aba-comunicacao">
            <h1 className="f600-18 ml-30 mt-20 mb-40">Chat</h1>

            <div className="list-message">
                <div className={(comunicacao && comunicacao.length) ? "mh-30 grid col-3 w-100" : "mh-30 grid w-100"}>

                    {(comunicacao && comunicacao.length)
                        ? comunicacao.map((item, index) => (
                            <div
                                key={`${item.id}-${index}`}
                                className={`f400-16 mb-20 p-20 message ${parseInt(item.id_usuario) === parseInt(user.id) ? 'message-my' : 'message'}`}
                            >
                                <div className="flex fd-fc">
                                    <span className="f400-14 mb-10 message-text">{item.texto}</span>
                                    {item.arquivos && item.arquivos.length ? (
                                        <div className="flex flex-wrap gap-10 mb-10">
                                            <span className="f400-14">Arquivos: </span>
                                            {item.arquivos.map((arquivo, index) => (
                                                <button key={index} onClick={() => { viewFile(arquivo, index) }} target="_blank" rel="noopener noreferrer" className="btn-link f400-14 pointer" >
                                                    <span>{(loadingFile && loadingFile?.fileId === arquivo.identificador) ? <Loading /> : arquivo.arquivo}</span>
                                                </button>
                                            ))}
                                        </div>
                                    ) : ''}
                                    <span className="f400-12 sender">
                                        <b>{item.usuario_nome}</b> - {moment(item.data_criacao, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY - HH:mm')} hrs
                                    </span>
                                </div>
                            </div>
                        ))
                        : 'Não há comentários no momento.'}
                </div>
            </div>

            <div className="form-message">
                <div className="mh-30 mb-10 flex flex-column gap-10">
                    {arquivos.map((arquivo, index) => (
                        <div className="flex" key={index}>
                            <span className="mr-5">{arquivo.texto}</span>
                            <i className="icon icon-cross-small i-20 pointer" onClick={() => removeArquivo(arquivo.id)}></i>
                        </div>
                    ))}
                </div>
                <div className="mh-30 grid col-12 w-100">
                    <div className="span-11 send-message">
                        <div className="flex gap-20">
                            <div className="send-text">
                                <textarea
                                    name="comentario"
                                    value={comentario.texto}
                                    disabled={loading}
                                    placeholder="Envie uma mensagem"
                                    onChange={e => setModel('comentario', e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                                            enviarMensagem(e);
                                        }
                                    }}
                                />
                            </div>

                            <div>
                                <Dropzone dropType="button" onDrop={onDrop} description={"Extensões: PDF, PNG, JPG, MP3 e OGG"} accept=".jpeg,.jpg,.png,.pdf,.mp3,.ogg" />
                            </div>

                            <div>
                                <button
                                    className="btn btn-primary f700-16 send-button"
                                    onClick={enviarMensagem}
                                    disabled={!comentario?.texto || loading}
                                >
                                    {loading ? <Loading /> : <i className={`icon icon-paper-plane ${!comentario?.texto ? 'blue' : ''} i-20`} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
